import { darken, lighten } from 'polished';

export const light = {
  colors: {
    background: '#0e4265',
    bgLight: '#f0f2f5',
    border: '#555555',
    fontColor: '#050505',
    headerBackground: '#5895a7',
    icon: '#a7b0c3',
    inputBackground: '#fff',
    inputFontColor: '#000000',
    light: '#dfe4ed',
    panel: '#fff',
    panelBorder: '#dfe4ed',
    panelHeader: '#36364B',
    placeholder: '#9e9e9f',
    placeholderLight: '#aab0c3',
    primary: '#4877c1',
    primaryHover: '#335894',
    red: '#e86250',
    secondary: '#8991a1',
    shadow: 'rgba(0,0,0,0.04)',
    surface: '#fafafc',
    textBody: '#36364b',
    textLight: '#5c8ddb',
    textPrimary: '#E1DFEB',
    textSecondary: '##9895A6',
    white: '#ffffff',
    bgNormal: '#1F1D29',
    bgDarken: '#1A1723',
  },
};

export const dark = {
  colors: {
    background: '#050505',
    bgLight: '#050505',
    border: '#555555',
    container: '#333333',
    fontColor: '#E9EAEC',
    headerBackground: '#333333',
    icon: '#a7b0c3',
    inputBackground: '#050505',
    inputFontColor: '#fff',
    light: '#777777',
    panel: '#333333',
    panelBorder: '#555555',
    panelHeader: '#555555',
    placeholder: '#9e9e9f',
    placeholderLight: '#aab0c3',
    primary: '#777777',
    primaryHover: '#335894',
    red: '#e86250',
    secondary: '#E9EAEC',
    shadow: '#222222',
    surface: '#fafafc',
    textBody: '#E9EAEC',
    textLight: '#333333',
    textPrimary: '#4877C1',
    white: '#ffffff',
    bgDarken: '#1A1723', //from here below, color for new design
    bgNormal: '#1F1D29',
    bgHighlight: '#302E3D',
    lnHighlight: '#88D1FF',
    areaTop: '#4e82a3',
    areaBottom: '#1b1d1f',
    txtPrimary: '#E1DFEB',
    txtSecondary: '#9895A6',
    txtThirdly: '656273',
    txtHighlight: 'FFDDA1',
    btnBuyLight: '5AC790',
    btnBuyNormal: '1C7E4C',
    btnSellLight: 'C75A5A',
    btnSellNormal: '7E1C1C',
  },
};

// I don't know yet what the difference between theme.js and colors.js, so I just duplicate the colors object here
export const darkNew = {
  colors: {
    // linghong variables
    bgHighlight: '#302E3D',
    lnHighlight: '#88D1FF',
    areaTop: '#4e82a3',
    areaBottom: '#1b1d1f',
    txtPrimary: '#E1DFEB',
    txtSecondary: '#9895A6',
    txtThirdly: '#656273',
    txtHighlight: '#FFDDA1',
    btnBuyLight: '#5AC790',
    btnBuyNormal: '#1C7E4C',
    btnSellLight: '#C75A5A',
    btnSellNormal: '#7E1C1C',

    highlightBlue: '#88d1ff',
    highlightYellow: '#ffdda1',
    highlightGreen: '#7cf9ba',
    highlightRed: '#c75a5a',
    textPrimary: '#e1dfeb',
    textSecondary: '#9895a6',
    textThirdly: '#656273',
    iconsNormal: '#8d89a3',
    iconsSecondary: '#5d5b70',
    bgHighlightBorder: '#302E3D',
    bgNormal: '#201d2a',
    bgDarken: '#1a1823',
    bgDarkest: '#06060f',

    bgHighlightBorder_darken: darken(0.1, '#302E3D'),
    bgHighlightBorder_lighten: lighten(0.1, '#302E3D'),
    bgNormal_darken: darken(0.02, '#201d2a'),
    bgNormal_lighten: lighten(0.02, '#201d2a'),
    textPrimary_darken: darken(0.02, '#e1dfeb'),
    textPrimary_lighten: lighten(0.02, '#e1dfeb'),
    textSecondary_darken: darken(0.02, '#9895a6'),
    textSecondary_lighten: lighten(0.02, '#9895a6'),
    textThirdly_darken: darken(0.1, '#656273'),
    textThirdly_lighten: lighten(0.1, '#656273'),
  },
};
